export enum PromoCodeRejectionReasons {
  PROMO_CODE_NOT_EXISTS = "PROMO_CODE_NOT_EXISTS",
  PROM_CODE_HAS_BEEN_USED = "PROM_CODE_HAS_BEEN_USED",
  BUCKET_SUM_IS_LESSER_THAN_PROMO_CODE_LIMIT = "BUCKET_SUM_IS_LESSER_THAN_PROMO_CODE_LIMIT",
  BUCKET_SUM_IS_GREATER_THAN_PROMO_CODE_LIMIT = "BUCKET_SUM_IS_GREATER_THAN_PROMO_CODE_LIMIT",
  BUCKET_CANNOT_BE_CALCULATED = "BUCKET_CANNOT_BE_CALCULATED",
}
